import React, { Component } from 'react'
import { any, string, bool, func } from 'prop-types'
import 'react-intl-tel-input/dist/libphonenumber.js'
import 'react-intl-tel-input/dist/main.css'
import IntlTelInput from 'react-intl-tel-input'
import { stores, view } from '../../../stores'

export class CountryInputComponent extends Component {
  constructor ({ value }) {
    super()
    this.state = {
      isValid: true,
      errors: [],
      code: value || ''
    }
  }

  componentWillReceiveProps ({ value }) {
    if (value) {
      this.setState({ code: value })
    }
  }

  validate (value) {
    value = value || this.refs[this.props.name].state.countryCode
    let valid = !!value
    if (!valid && !value) {
      valid = !this.props.required
    }
    const errors = valid ? [] : [{ message: 'Ce champ est obligatoire' }]
    return { isValid: valid, errors: errors }
  }

  handleChange (value, infos) {
    const { isValid, errors } = this.validate(infos.iso2)

    if (this.props.onChange) {
      this.props.onChange(infos.iso2, isValid)
    }

    this.setState({ name: infos.name, code: infos.iso2 })
    clearTimeout(this._rulesValidationTimeout)
    this._rulesValidationTimeout = setTimeout(() => {
      this.setState({ isValid, errors })
    }, 500)
  }

  /*
  * Validation handler called on value change
  */
  handleValidation () {
    const result = this.validate()
    this.setState({...result})
    return { label: this.props.label, ...result }
  }

  render () {
    const { isValid, errors } = this.state
    const { name, className, bold, label } = this.props

    if (!stores.countries.initialized) {
      return null
    }

    const country = stores.countries.getCountryByCode({ code: this.state.code }) || stores.countries.getCountryByCode({ code: this.props.defaultCountry }) || { name: '' }

    return (
      <div>
        <div className='clearfix'>
          <label
            style={(bold) ? {fontWeight: 500} : {}}
            className={'form__label' + (!isValid ? ' form__label--error' : '')}
            htmlFor={name}>{label}</label>
          <IntlTelInput
            placeholder=''
            preferredCountries={[this.props.defaultCountry]}
            autoPlaceholder={false}
            countriesData={stores.countries.countries}
            value={country.name}
            defaultCountry={this.state.code || this.props.defaultCountry}
            onSelectFlag={(value, infos) => this.handleChange(value, infos)}
            css={className ? [className, 'intl-tel-input form__input intl-country-input' + (!isValid ? ' form__input-error' : '')] : ['intl-tel-input form__input intl-country-input' + (!isValid ? ' form__input-error' : '')]}
            utilsScript={'libphonenumber.js'}
            fieldId={name}
            ref={name}
            id={name}
            />
        </div>
        {
          !isValid && errors.length
          ? <p className='form__errormessage' >{errors[0].message}</p>
          : ''
        }
      </div>
    )
  }
}

CountryInputComponent.propTypes = {
  value: any,
  name: string,
  label: string,
  bold: bool,
  defaultCountry: string,
  required: bool,
  className: string,
  onChange: func
}

CountryInputComponent.defaultProps = {
  defaultCountry: 'fr'
}

export const CountryInput = view(CountryInputComponent)



// WEBPACK FOOTER //
// ./src/components/ui/inputs/CountryInput.js